import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'

import Login from '@/view/login/state'
import ItemAssociation from '@/view/item-association/state'
import Stock from '@/view/record/stock/state'
import Events from '@/view/event/state'
import EventMap from '@/view/event-map/state'
import Board from '@/view/board/state'
import Rms from '@/view/event-rms/state'
import BidMirror from '@/view/bid-mirror/state'
import Realtime from '@/brain/realtime'
import Cbpf from '@/view/record/cbpf/state'
import Result from '@/view/event-result/state'
import Quote from '@/view/item-quote/state'
import Suppliers from '@/view/record/suppliers/state'
import Distributors from '@/view/record/distributor/state'
import Dashboard from '@/view/dashboard/state'
import EventDocuments from '@/view/event-documents/state'
import ItemPricing from '@/view/item-pricing/state'
import DocumentType from '@/view/record/document-type/state'

Vue.use(Vuex)

// const persistedModules = process.env.NODE_ENV === 'production'
//   ? {
//     paths: ['Login',
//       'Events',
//       'EventMap',
//       'ItemAssociation',
//       'Board',
//       'Rms',
//       'Realtime',
//       'BidMirror',
//       'Stock',
//       'Cbpf',
//       'Result',
//       'Quote',
//       'Suppliers',
//       'Distributors',
//       'Dashboard',
//       'ItemPricing',
//       'DocumentType']
//   }
//   : { paths: [] }

const persistedModules = {
  paths: ['Login',
    'Events',
    'EventMap',
    'ItemAssociation',
    'Board',
    'Rms',
    'Realtime',
    'BidMirror',
    'Stock',
    'Cbpf',
    'Result',
    'Quote',
    'Suppliers',
    'Distributors',
    'Dashboard',
    'ItemPricing',
    'DocumentType']
}
const dataState = createPersistedState(persistedModules)

export default new Vuex.Store({
  plugins: [dataState],
  modules: {
    root: true,
    Login,
    Events,
    EventMap,
    EventDocuments,
    ItemAssociation,
    Board,
    Rms,
    Realtime,
    BidMirror,
    Stock,
    Cbpf,
    Result,
    Quote,
    Suppliers,
    Distributors,
    Dashboard,
    ItemPricing,
    DocumentType
  }
})



// WEBPACK FOOTER //
// ./src/state/index.js